import * as Sentry from '@sentry/vue';

/**
 * Report an error that was caught and handled.
 *
 * Sentry only sees uncaught exceptions, and almost everything in this codebase
 * is caught and logged to a console nobody reads. That is how the AI prefills
 * managed to return nothing for two and a half years without a single signal
 * anywhere - the errors were all being handled, just not reported.
 *
 * Use this where a catch block means something genuinely went wrong. Do not use
 * it for conditions the code expects, such as a user typing the wrong password
 * or not having configured an API key: those are already shown to the user and
 * would only add noise here.
 *
 * Safe to call when Sentry was never initialised - it is a no-op in dev.
 *
 * @param {Error} error the caught error
 * @param {object} context anything that helps identify where it came from
 */
export default function reportHandledError(error, context = {}) {
  console.error(error, context);

  Sentry.captureException(error, { extra: context });
}
